import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

class CameraName extends React.Component {
  constructor(props) {
    super(props)
    const { currentCamera } = this.props

    this.state = {
      editName: false,
      name: currentCamera ? currentCamera.name : '',
      previousName: currentCamera ? currentCamera.name : ''
    }
  }

  componentWillReceiveProps = nextProps => {
    const { currentCamera } = nextProps
    currentCamera && this.setState({ name: currentCamera.name, previousName: currentCamera.name })
  }

  setName = value => {
    const { currentCamera: { id }, updateCalculatorAction } = this.props

    this.setState({ name: value })
    value.trim() !== '' && updateCalculatorAction(value, 'name', id)
  }

  onChange = ({ target: { value } }) => this.setName(value)

  onKeyPress = e => {
    if (e.key === 'Enter') {
      this.setState({ editName: false })
      this.onBlur()
    }
  }

  onFocus = _ => {
    this.setState({ previousName: this.state.name })
  }

  onBlur = _ => {
    const { state: { name, previousName } } = this
    name.trim() === '' && this.setName(previousName)
  }

  render() {
    const { onChange, onKeyPress, onFocus, onBlur, props: { currentCamera, updateCalculatorAction, classes }, state: { editName, name } } = this

    return (
      editName
      ? <div className={classes.editName}>
          <input
            type='text'
            className={classes.nameInput}
            value={name}
            ref='name'
            { ...{ onChange, onKeyPress, onFocus, onBlur } }
          />
          <FontAwesomeIcon icon='check' className={classes.saveIcon} onClick={_ => this.setState({ editName: false })} />
        </div>
      : <div className={classes.name}>
          <span style={{ flex: 1 }}>{ name }</span>
          <FontAwesomeIcon icon='pen' className={classes.editIcon} onClick={_ => this.setState({ editName: true }, _ => this.refs.name && this.refs.name.focus())} />
        </div>
    )
  }
}

export default CameraName



// WEBPACK FOOTER //
// ./src/components/BottomBar/CameraConfig/CameraName/index.js